module.exports = __webpack_public_path__ + "static/media/payment-details.2c7bf496.svg";